var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"content":`${_vm.content}: ${_vm.valueFormatter(_vm.scope.row[_vm.fields]) || '⏤'}`,"placement":"bottom","effect":"light"}},[_c('div',{staticClass:"triangle-topright"})]),_c('span',[_vm._v(_vm._s(_vm.valueFormatter(_vm.row[_vm.column.property])))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }